import { isPlaceholder } from '../../config/legal';

/**
 * A business or legal value that has not been settled yet.
 *
 * Renders the token with a marker so an unresolved value is obvious on the
 * page rather than reading as finished copy. Once the value is filled in in
 * config/legal.js it renders as ordinary text.
 */
export function Value({ children }) {
  if (!isPlaceholder(children)) return children;

  return (
    <mark className="legal-placeholder" title="Pending business or legal decision">
      {children}
    </mark>
  );
}

/** A mailto link that degrades to a marked token while the address is unset. */
export function LegalEmail({ address }) {
  if (isPlaceholder(address)) return <Value>{address}</Value>;
  return <a href={`mailto:${address}`}>{address}</a>;
}

/** A defined term on first use. */
export function Term({ children }) {
  return <strong className="legal-term">{children}</strong>;
}
